var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolexRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30,30H0V0h30V30z M1,29H29V1H1V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6,26.1H4V3.9h22.6V26.1z M4.9,25.1h20.7V4.8H4.9V25.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6,22.5l-0.2,0c-0.2-0.1-0.3-0.4-0.2-0.6l6.8-14.4c0.1-0.2,0.4-0.3,0.6-0.2c0.2,0.1,0.3,0.4,0.2,0.6L8,22.2 C7.9,22.4,7.7,22.5,7.6,22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2,17.2c-0.2,0-0.4-0.1-0.4-0.3l-3.8-9.1c-0.1-0.2,0-0.5,0.3-0.6c0.2-0.1,0.5,0,0.6,0.3l3.8,9.1c0.1,0.2,0,0.5-0.3,0.6 L18.2,17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,17.2h-2.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H21c0.3,0,0.5,0.2,0.5,0.5S21.2,17.2,21,17.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "20.3,14.5 24.2,16.8 20.3,19  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolexRight);
export default __webpack_public_path__ + "static/media/folex_right.47e7578ab4fc792ac1b6dab6444ef2e4.svg";
export { ForwardRef as ReactComponent };